<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg4 pr-6 pl-6>
          <v-layout row wrap justify-end>
            <v-menu
                v-model="menuStart"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="computedStartDateFormatted"
                    label="Từ ngày"
                    hint="DD-MM-YYYY"
                    persistent-hint
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
            </v-menu>
          </v-layout>
        </v-flex>
        <v-flex lg4 pr-6>
          <v-layout row wrap justify-end>
            <v-menu
                v-model="menuEnd"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="computedEndDateFormatted"
                    label="Đến ngày"
                    hint="DD-MM-YYYY"
                    persistent-hint
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
            </v-menu>
          </v-layout>
        </v-flex>
        <v-flex lg2 pr-6>
            <v-btn @click="filter_data" color="#a41c21" outlined>Xem</v-btn>
        </v-flex>
        <v-flex lg12>
            <v-data-table hide-default-footer :headers="headers" :items="items" :server-items-length="items.length" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>{{ item.ReportDate }}</td>
                        <td class="text-end">{{ item.TotalReceipt | currency}}</td>
                        <td class="text-end">{{ item.TotalPackage | currency}}</td>
                        <td class="text-end">{{ item.TotalWeight | currency('',1)}}</td>
                        <td class="text-end">{{ item.TotalVolume | currency('',2)}}</td>
                        <td class="text-end">{{ item.TotalAmount | currency('',0)}}</td>
                        <td class="text-end">{{ item.TotalCost | currency('',0)}}</td>
                        <td class="text-end">{{ item.TotalProfit | currency('',0)}}</td>
                    </tr>
                </template>
                <template v-slot:body.append>
                    <tr>
                        <td class="font-weight-bold">TỔNG</td>
                        <td class="text-end font-weight-bold">{{dic_summary.TotalReceipt | currency}}</td>
                        <td class="text-end font-weight-bold">{{dic_summary.TotalPackage | currency}}</td>
                        <td class="text-end font-weight-bold">{{dic_summary.TotalWeight | currency('',1)}}</td>
                        <td class="text-end font-weight-bold">{{dic_summary.TotalVolume | currency('',2)}}</td>
                        <td class="text-end font-weight-bold">{{dic_summary.TotalAmount | currency('', 0)}}</td>
                        <td class="text-end font-weight-bold">{{dic_summary.TotalCost | currency('', 0)}}</td>
                        <td class="text-end font-weight-bold">{{dic_summary.TotalProfit | currency('', 0)}}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
import moment from "moment"
export default {
    data() {
        return {
            pagination: _.cloneDeep(configs.PAGINATION),
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "thong-ke-xuat-hang",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false,
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
    },
    computed: {
        ...mapState({
            items: state => state.report.receipt.data,
            loading: state => state.report.loading
        }),
        computedStartDateFormatted () {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted () {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        roleAdmin() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin;
        },
        dic_summary() {
            return {
                'TotalWeight': _.sumBy(this.items, 'TotalWeight'),
                'TotalVolume': _.sumBy(this.items, 'TotalVolume'),
                'TotalPackage': _.sumBy(this.items, 'TotalPackage'),
                'TotalReceipt': _.sumBy(this.items, 'TotalReceipt'),
                'TotalAmount': _.sumBy(this.items, 'TotalAmount'),
                'TotalCost': _.sumBy(this.items, 'TotalCost'),
                'TotalProfit': _.sumBy(this.items, 'TotalProfit'),
            };
        },
        headers() {
            return [
                {
                    text: "Ngày",
                    value: "ReportDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Số bao hàng",
                    value: "TotalReceipt",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Số MVĐ",
                    value: "TotalPackage",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng cân",
                    value: "TotalWeight",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng khối",
                    value: "TotalVolume",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng doanh thu",
                    value: "TotalAmount",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng chi phí",
                    value: "TotalCost",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng lợi nhuận",
                    value: "TotalProfit",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                }
            ];
        }
    },
    methods: {
        filter_data: function () {
            var param = {
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT),
                pagination: {
                        sortDesc: this.pagination.sortDesc,
                        sortBy: this.pagination.sortBy
                    }
            };
            this.$store.dispatch("report/getReceipt", param);
        }
    },
    mounted() {
        this.filter_data();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>